import { createContext, useCallback, useContext, useEffect } from 'react';
export interface WorkTabContextValue {
  managed: boolean;
  companion: boolean;
  fieldPrefix: string;
  active: boolean;
  update: (changes: {
    title?: string;
    dirty?: boolean;
    busy?: boolean;
    path?: string;
    listPath?: string;
  }) => void;
  close: () => void;
}
export const WorkTabContext = createContext<WorkTabContextValue>({
  managed: false,
  companion: false,
  fieldPrefix: '',
  active: true,
  update: () => undefined,
  close: () => undefined,
});
export function useWorkTab({
  title,
  dirty,
  busy,
  listPath,
}: {
  title?: string | undefined;
  dirty?: boolean;
  busy?: boolean;
  listPath?: string | undefined;
} = {}): WorkTabContextValue & {
  setDirty: (value: boolean) => void;
} {
  const value = useContext(WorkTabContext);
  const { update } = value;
  useEffect(() => {
    update({
      ...(title === undefined ? {} : { title }),
      ...(dirty === undefined ? {} : { dirty }),
      ...(busy === undefined ? {} : { busy }),
      ...(listPath === undefined ? {} : { listPath }),
    });
  }, [title, dirty, busy, listPath, update]);
  return { ...value, setDirty: (next) => value.update({ dirty: next }) };
}
export function newWorkPath(path: string): string {
  const [pathname, search] = path.split('?');
  const params = new URLSearchParams(search);
  params.set('draft', crypto.randomUUID());
  return `${pathname}?${params}`;
}

/** Scope form labels and validation targets to one retained record. */
export function useWorkFieldId(): (id: string) => string {
  const { fieldPrefix } = useContext(WorkTabContext);
  return useCallback(
    (id: string) => (id.startsWith(fieldPrefix) ? id : `${fieldPrefix}${id}`),
    [fieldPrefix],
  );
}
